import { BoardLocalPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const BoardLocalPersistenceProvider = createStaticContextProvider(
  BoardLocalPersistenceContext,
  lazyValue(() =>
    import("./board-local-persistence").then(
      (module) => module.boardLocalPersistence,
    ),
  ),
);
